import { Button, FormControlLabel, Radio, RadioGroup, TextField, Select, MenuItem } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory, useLocation } from "react-router-dom";
import '../index.css';
import http from "../services/httpService";
import handleSubmitValidation from '../utils/handleSubmitValidation';
import handleValidation from '../utils/handleValidations';
import { userManagementPath, executiveListPath, investmentPath, prospectPath } from "../utils/varialbles";
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
// import { MultiSelect } from "react-multi-select-component";
import { ListItemIcon, Checkbox, ListItemText, } from "@material-ui/core";
import { selectedGridRowsCountSelector } from '@material-ui/x-grid';



const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        paddingTop: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    submitButton: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(10),


    },
    gridDevider: {
        marginTop: theme.spacing(6),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    lableColor: {
        color: "#393939"
    },
    // select: {
    //     height: 36,
    //     minWidth: 235,        
    // },
    mobileCode: {
        height: 36,
    },
    radio: {
        '&$checked': {
            color: '#57bf74'
        }
    },

    checked: {}
}));

let disableReporting = false;
let updateEmpfname = null;
let reportingID = null;

function EditUser() {

    const location = useLocation();
    const [formObject, setFromObject] = useState({});

    const [editFrom, setEditFrom] = useState(false);


    const [userId, setUserId] = useState(null);
    // (userId);
    const classes = useStyles();
    const history = useHistory();
    const [rolesDropDowm, setRolesDropDowm] = useState([]);
    const [selected, setSelected] = useState([]);
    // (selected);
    // const selectjsonData= (selected && selected.length > 0) ? JSON.parse(selected.languages.split("\'").join('\"')).join(",") : ""
    // (selectjsonData);
    // let selectArrayData= selected.map((item) => {
    //     return(
    //         JSON.parse(item.split("\'").join('\"').join(","))   
    // );})

    // (selectArrayData);

    // .split("\'").join('\"')).join(",") : ""
    //     {Users.map((e)=>{
    //    return (
    //     <Info name={e.name} rollNo={e.rollNo}/>
    //   );})}
    // (selectjsonData);
    const [sourceSelected, setSourceSelected] = useState([]);


    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: { style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250 } },
        getContentAnchorEl: null, anchorOrigin: { vertical: "bottom", horizontal: "center" },
        transformOrigin: { vertical: "top", horizontal: "center" }, variant: "menu"
    };


    const handleLangChange = (e) => {
        setSelected(e.target.value);
        // (e.target.value);
        setFromObject({ ...formObject, languages: e.target.value })
    }

    const handleSourceChange = (e) => {
        setSourceSelected(e.target.value);
        setFromObject({ ...formObject, source: e.target.value })
    }

    const myparam = location.state;
    // (myparam);
    let form = {
        "empfname": "",
        "emplname": "",
        "empdept": "",
        "empphone": "",
        "empemail": "",
        "empassignstatus": false,
        // "emppassword": "",
        "empnickname": "",
        "empintassignstatus": false,
        "languages": [],
        "firstlan": [],
        "seclan": [],
        "thirdlan": [],
        "reporting": "",
        "source": "",
        "cap": null,
        "reporting_id": "",
    }
    // (form);
    const columns = [
        { "value": 'empfname', "label": 'First Name', "minWidth": 170, "imp": true, "filedType": "text" },
        { "value": 'emplname', "label": 'Last Name', "minWidth": 150, "imp": true, "filedType": "text" },
        { "value": 'empnickname', "label": 'Nickname', "minWidth": 150, "imp": true, "filedType": "text" },
        { "value": 'empphone', "label": 'Mobile Number', "minWidth": 150, "imp": true, "filedType": "text" },
        { "value": 'languages', "label": 'Languages', "minWidth": 150, "imp": true, "filedType": "select1" },
        { "value": 'empdept', "label": 'Role', "minWidth": 150, "imp": true, "filedType": "dropdown" },
        { "value": 'empemail', "label": 'Email', "minWidth": 150, "imp": true, "filedType": "text" },
        //{ "value": 'emppassword', "label": 'Password', "minWidth": 150, "imp": true, "filedType": "password" },
        { "value": 'cap', "label": 'Cap', "minWidth": 150, "imp": false, "filedType": "text" },
        { "value": 'reporting', "label": 'Reporting To', "minWidth": 170, "imp": true, "filedType": "select3" },
        { "value": 'source', "label": 'Prospect Source', "minWidth": 170, "imp": false, "filedType": "select2" },
        { "value": 'empassignstatus', "label": 'Do you want to assign leads to this user?', "minWidth": 150, "imp": true, "filedType": "radio", "options": [{ "label": "Yes", "value": true }, { "label": "No", "value": false }] },
        { "value": 'empintassignstatus', "label": 'Do you want to assign international leads to this user?', "minWidth": 150, "imp": true, "filedType": "radio", "options": [{ "label": "Yes", "value": true }, { "label": "No", "value": false }] }
    ];
    // (columns[9].value);
    const validations = {
        "empfname": {
            conditions: {
                "required": true, "maxLength": 50
            }, "message": "This Field is required!", "valid": true, "changed": false
        },
        "emplname": {
            conditions: {
                "required": true, "maxLength": 50
            }, "message": "Maximum 20 character Allowed.!", "valid": true, "changed": false
        },
        "empdept": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "empnickname": {
            conditions: {
                "required": true, "maxLength": 50
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "empemail": {
            conditions: {
                "required": true, "maxLength": 100
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "empphone": {
            conditions: {
                "required": true, "minLength": 9, "pattren": /^[0-9\b]+$/, "maxLength": 12
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "languages": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },

        "firstlan": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "seclan": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "thirdlan": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        // "emppassword": {
        //     conditions: {
        //         "required": true,"minLength":8
        //     }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        // },
        "reportingto": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "prospectsource": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "empassignstatus": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "empintassignstatus": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        }

    }
    const [validationState, setValidationState] = useState(validations)

    // const [langval, setlangval] =useState([]);

    const [langName, setLangName] = React.useState([]);
    const [sorceName, setsourceName] = React.useState([]);
    const [reportName, setreportName] = React.useState([]);

    const [getReportingid, setReportingid] = useState('');


    useEffect(() => {
        http.get("/permission_manager").then(res => {
            if (res && res.data && res.data.Roles && Array.isArray(res.data.Roles) && res.data.Roles.length > 0) {
                setRolesDropDowm(res.data.Roles);
            }
            if (myparam && myparam.id) {
                http.get("/edit_employee/" + myparam.id,
                ).then((response) => {
                    // (response.data.data[0]);
                    if (response.data.data[0] && response.data.data[0].id && response.data.data[0].id === myparam.id) {
                        setEditFrom(true)
                        setUserId(response.data.data[0].id);
                        let role = res.data.Roles.filter(role => {
                            return response.data.empdept && role.role === response.data.empdept
                        })

                        let editData = response.data.data[0]

                        setSelected(editData.languages);
                        // setSourceSelected(editData.source);

                        if (editData.empdept === "Business Growth Executive") {
                            disableReporting = false

                        }
                        else {
                            disableReporting = true

                        }
                        updateEmpfname = editData.reporting_id;
                        reportingID = editData.reporting_id;
                        let newForm = {
                            "empfname": editData.empfname,
                            "emplname": editData.emplname,
                            "empdept": editData.empdept,
                            "empphone": editData.empphone,
                            "empemail": editData.empemail,
                            "empassignstatus": editData.empassignstatus,
                            // "emppassword": "",
                            "empnickname": editData.empnickname,
                            "empintassignstatus": editData.empintassignstatus,
                            "languages": editData.languages,
                            "firstlan": editData.firstlan,
                            "seclan": editData.seclan,
                            "thirdlan": editData.thirdlan,
                            // "languages": (selected && selected.length > 0) ? JSON.parse(selected.split("\'").join('\"')).join(",") : "",
                            // "languages":selected,
                            // "source":(editData.source && editData.source.length > 0) ? JSON.parse(editData.source.split("\'").join('\"')).join(",") : "",
                            // "source":sourceSelected,
                            "source": editData.source,
                            "reporting": editData.reporting_to,
                            // "reporting_id":editData.reporting_id,
                            "cap": editData.cap
                        }
                        // (newForm);
                        setFromObject(newForm)
                    }
                    //  changeAciveTab(1)
                }).catch((error) => {
                })
            } else {
                history.goBack()
                setFromObject(form)
            }
        }).catch((error) => {
        })

        http.get("/edit_employee/" + myparam.id).then(res => {
            // (res.data.data[0].id);
            // setlangval(res.data.languages);
            // (res.data.source);
        }).catch(err => {
            // (err);
        });


        http.get('/userdropdown').then(res => {

            setLangName(res.data.languages);
            setsourceName(res.data.source);
            setreportName(res.data.reporting);
        })


        // (formObject.reporting_id, "reportingid"); 

        //   const abc=
        //     reportName.filter((item)=>{            
        //         if(item.id === formObject.reporting_id){
        //             return item.id
        //             // setReportingid(item.id);
        //         }
        //     })


        //   (abc, 'abcid');

        //   abc.map((item)=>{
        //     setReportingid(item.id);
        //   })

        reportName.filter((item) => {
            if (item.id === formObject.reporting_id) {
                setReportingid(item.id);
                setFromObject({
                    ...formObject,
                    "reporting": item.id
                })
            }
        })

    }, [])

    // (getReportingid);


    const handleChange = (event, boolean) => {
        // updateReportingValue=false;
        let name = event.target.name;
        let value = event.target.value;

        let valid = true;
        let validStateTemp = { ...validationState }
        if (name === "empdept") {
            if (name === "empdept" && (value === "Business Growth Executive")) {
                disableReporting = false
            }

            else {
                disableReporting = true
            }
        }
        if (boolean && value === 'false') {
            value = false
        } else if (boolean && value == 'true') {
            value = true
        }
        if (name && validStateTemp.hasOwnProperty(name)) {
            let validation = handleValidation(name, value, validStateTemp);

            setValidationState(validation.validStateTemp)
            valid = validation.valid
        }
        if (name === "reporting") {
            reportingID = value;
        }
        if (valid || value === "" || value == 0) {

            setFromObject({
                ...formObject,
                [event.target.name]: value
            });
        }
    }

    const handleSubmit = (event) => {
        let finalObject = { ...formObject }

        let role = rolesDropDowm.filter(role => {
            return role.id === finalObject.empdept
        })

        if (role && role.length > 0) {
            finalObject.empdept = role[0]['role'];
        } else {
            finalObject.empdept = null;
        }
        if (finalObject.empdept) {
            http.post("/userlist", finalObject,
            ).then((response) => {
            }).catch((error) => {
            })
        } else {
            toast.error('please Select Role');
        }

    }
    const handleEditForm = (event) => {
        event.preventDefault();

        let validStateTemp = { ...validationState }
        let validCount = 0;
        let finalObject = {
            ...formObject,
        };
        finalObject.reporting = reportingID

        // (formObject, "formobject");    
        // if(updateReportingValue=== false) {
        // }
        // else {
        //     // finalObject.reportingto=finalObject.reportingto
        // }
        // (finalObject,abcd,'finalObject');


        if (finalObject.cap === "") {
            finalObject.cap = null
        }
        // if(finalObject.reporting)

        let validData = handleSubmitValidation(finalObject, validStateTemp)
        validCount = validData.validCount;
        if (validCount === 0) {
            // let role = rolesDropDowm.filter(role => {
            //     return role.id === finalObject.empdept
            // })
            // if (role && role.length > 0) {
            //     finalObject.empdept = role[0]['role'];
            // } else {
            //     finalObject.empdept = null;
            // }

            http.put("/edit_employee/" + userId + "/", finalObject,
            ).then((response) => {
                if (response && response.data && response.data.data && response.data.statusCode === 0) {
                    toast.success("User Data Updated successfully..!");
                    // history.goBack()

                    history.push(
                        {
                            state: {
                                page: myparam.page
                            },
                            pathname: userManagementPath
                        }
                    )

                    if (location.string === "executivelist") {
                        history.push(
                            {
                                pathname: investmentPath
                            }
                        )
                    }

                    if (location.string === "propexecutivelist") {
                        history.push(
                            {
                                pathname: prospectPath
                            }
                        )
                    }

                } else {
                    toast.error("User Data Update Failed..!");
                }
            }).catch((error) => {
            })
        } else {
            setValidationState(validData.validStateTemp);
            toast.error("Please check Errors in Field level!")
        }
    }
    const goBack = (e) => {
        // history.goBack()
        // e.preventDefault();
        // history.push(
        //     {
        //         state:{
        //             page:myparam.page
        //         },                
        //         pathname:userManagementPath
        //     }
        //     )

        //     if(location.string === "executivelist"){
        //         history.push(
        //             {                                       
        //                 pathname:investmentPath
        //             }
        //             )
        //     } 
        //     if(location.string === "propexecutivelist"){
        //         history.push(
        //             {                                       
        //                 pathname:prospectPath
        //             }
        //             )
        //     } 

        if (location.string === "propexecutivelist") {
            history.push({
                pathname: prospectPath, state: { "tab": "Executive List" }
            });
        } else if (location.string === "executivelist") {
            history.push({
                pathname: investmentPath, state: { "tab": "Executive List" }
            });
        } else {
            history.push({
                pathname: userManagementPath, state: { "tab": "Overview" }
            });
        }
    }


    // (langName);

    // useEffect(()=>{
    //     http.get('/userdropdown').then(res=>{
    //         // (res.data); 
    //         setLangName(res.data.languages); 
    //         setsourceName(res.data.source);
    //         setreportName(res.data.reporting);      
    //     }).catch(err=>{
    //         // (err);
    //     });
    // },[]);

    // const languages=['English', 'Hindi', 'Telugu'];

    //     const languages = [
    //         { label: "English", value: "english" },
    //   { label: "Hindi", value: "hindi" },
    //   { label: "Telugu", value: "telugu"},
    //       ];

    //     const [langName, setLangName] = React.useState([]);
    //     // (langName);

    //     const source = [
    //         { label: "Organic", value: "organic" },
    //   { label: "Inorganic", value: "inorganic" }
    //       ];

    //     const [sourceName, setSourceName] = React.useState([]);
    //     // (sourceName);

    // const handleChangelang = (event) => {
    //   setPersonName({...personName, [event.target.name]:event.target.value});
    // };

    // function abc=()=>{
    // 


    //   }


    return (

        <Grid container component="main" style={{ marginTop: 30, marginBottom: 30 }}>

            <Grid item xs={false} sm={5} md={5} >
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={goBack}>Back</Button>
            </Grid>
            <Grid item xs={false} sm={5} md={5} >
                <Typography color="textPrimary" variant="h5" >Edit User</Typography>
            </Grid>
            {
                columns.map(question => {
                    return (
                        <Grid container className={classes.paper}>
                            <Grid item xs={false} sm={3} md={3} >
                                <InputLabel className={classes.lableColor} id={question.lable}>{question.label}
                                    {question.imp && <span style={{ color: 'red', fontSize: '1.2rem', marginLeft: '0.2rem' }}>*</span>}
                                </InputLabel>
                            </Grid>
                            {/* <Grid item lg={3} md={3} sm={3}>{question.filedType === "text" || question.filedType === "password" ?
                                <TextField label={editFrom ? "" : "Enter"} variant="outlined" value={formObject[question.value]} name={question.value} onChange={e => handleChange(e, false)} type={question.filedType}
                                style={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? { paddingBottom: 20 } : {}}
                                error={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid']}
                                helperText={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? validationState[question.value]['message'] : ""} */}
                            <Grid item lg={9} md={3} sm={3}>
                                {question.filedType === "text" ?
                                    <TextField label={editFrom ? "" : "Enter"}

                                        disabled={disableReporting === true && question.value === "cap"}

                                        variant="outlined" value={formObject[question.value]} name={question.value} onChange={e => handleChange(e, false)} type={question.filedType}
                                        style={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? { paddingBottom: 20 } : {}}
                                        error={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid']}
                                        helperText={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? validationState[question.value]['message'] : ""}
                                    /> : question.filedType === "radio" ?
                                        <RadioGroup row aria-label="position" name={question.value} value={formObject[question.value] ? formObject[question.value] : false} onChange={e => handleChange(e, true)}>
                                            {
                                                question.options.map(option => {
                                                    return (
                                                        <FormControlLabel
                                                            control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value={option.value} />}
                                                            label={option.label}
                                                            labelPlacement="end"
                                                        />
                                                    )
                                                })

                                            }


                                        </RadioGroup> : question.filedType === "dropdown" ? <>

                                            {/* <Select displayEmpty labelId={"Role" + "label"} id="roleSelect" variant="outlined"  onChange={e => handleChange(e, true)} value={(formObject[question.value]) ? formObject[question.value] : ""} className="roleselect">
                                        <MenuItem value="">Select</MenuItem>name={question.value}
                                        {rolesDropDowm.map((option, index) => {
                                            return <MenuItem value={option.id} key={"role" + index}>{option.role}</MenuItem>
                                        })}
                                        ){e => handleChange(e, true)}
                                    </Select> */}

                                            <select
                                                value={(formObject[question.value]) ? formObject[question.value] : ""}
                                                name={question.value}
                                                onChange={e => handleChange(e, true)}
                                                style={{ width: 209, height: 40 }}
                                            >
                                                <option value="">{(formObject[question.value]) ? formObject[question.value] : ""}</option>
                                                {rolesDropDowm.map((option, index) => {

                                                    return <option>{option.role}</option>
                                                })}
                                            </select>

                                            {/* {validationState.hasOwnProperty(question.value)
                                        && validationState[question.value]['changed'] &&
                                        !validationState[question.value]['valid'] ?
                                        <div style={{ color: "#f44336", fontSize: "0.75rem", margin: "3px 14px" }}>{validationState[question.value]['message']}</div> : null} */}
                                        </> :
                                            question.filedType === "select1" ? <>
                                                {/* <InputLabel id="mutiple-select-label">Language</InputLabel> className={classes.select}*/}
                                                {/* <Select labelId="mutiple-select-label"
                                                multiple value={selected}
                                                onChange={handleLangChange}
                                                // onChange={e => handleChange(e, true)}
                                                renderValue={(selected) => selected.join(", ")}
                                                // renderValue={(selected) => null}
                                                MenuProps={MenuProps}
                                                style={{ width: 210, height: 40 }}
                                                variant="outlined"
                                            >
                                                {langName.map((option) => (<MenuItem value={option}>
                                                    <ListItemIcon>
                                                        <Checkbox checked={selected.indexOf(option) > -1} />
                                                    </ListItemIcon> <ListItemText primary={option} /> </MenuItem>))}
                                            </Select> */}
                                                <>
                                                    <Grid container>

                                                        <Grid item xs={5} sm={5} md={3}
                                                            id='firstlan' >
                                                            <InputLabel id="mutiple-primary-select-label">Primary Language</InputLabel>
                                                            <>
                                                                <Select
                                                                    displayEmpty
                                                                    labelId="statusLable"
                                                                    id="statusSelect"
                                                                    variant="outlined"
                                                                    className={classes.select}

                                                                    value={formObject.firstlan ? formObject.firstlan : ""}
                                                                    onChange={(e) => {

                                                                        setFromObject({ ...formObject, firstlan: e.target.value })


                                                                    }}
                                                                    style={{
                                                                        width: '210px',
                                                                        marginRight: '10px'
                                                                    }}
                                                                >
                                                                    <MenuItem value="">Select</MenuItem>
                                                                    {langName.map((option) => {
                                                                        return (
                                                                            <MenuItem
                                                                                value={option}
                                                                                key={option}
                                                                            >
                                                                                {option}
                                                                            </MenuItem>
                                                                        );
                                                                    })}

                                                                </Select>

                                                            </>
                                                        </Grid>
                                                        <Grid item xs={5} sm={5} md={3} id='firstlan'>
                                                            <InputLabel id="mutiple-primary-select-label">Secondary Language</InputLabel>
                                                            <>
                                                                <Select
                                                                    displayEmpty
                                                                    labelId="statusLable"
                                                                    id="statusSelect"
                                                                    variant="outlined"
                                                                    className={classes.select}

                                                                    value={formObject.seclan ? formObject.seclan : ""}
                                                                    onChange={(e) => {

                                                                        setFromObject({ ...formObject, seclan: e.target.value })


                                                                    }}
                                                                    style={{
                                                                        width: '210px',

                                                                    }}
                                                                >
                                                                    <MenuItem value="">Select</MenuItem>
                                                                    {langName.map((option) => {
                                                                        return (
                                                                            <MenuItem
                                                                                value={option}
                                                                                key={option}
                                                                            >
                                                                                {option}
                                                                            </MenuItem>
                                                                        );
                                                                    })}

                                                                </Select>
                                                            </>
                                                        </Grid>
                                                        <Grid item xs={5} sm={5} md={3}
                                                            id='firstlan'
                                                        >
                                                            <InputLabel id="mutiple-primary-select-label">Third Language</InputLabel>
                                                            <>
                                                                <Select
                                                                    displayEmpty
                                                                    labelId="statusLable"
                                                                    id="statusSelect"
                                                                    variant="outlined"
                                                                    className={classes.select}

                                                                    value={formObject.thirdlan ? formObject.thirdlan : ""}
                                                                    onChange={(e) => {

                                                                        setFromObject({ ...formObject, thirdlan: e.target.value })


                                                                    }}
                                                                    style={{
                                                                        width: '210px',
                                                                    }}
                                                                >
                                                                    <MenuItem value="">Select</MenuItem>
                                                                    {langName.map((option) => {
                                                                        return (
                                                                            <MenuItem
                                                                                value={option}
                                                                                key={option}
                                                                            >
                                                                                {option}
                                                                            </MenuItem>
                                                                        );
                                                                    })}

                                                                </Select>
                                                            </>
                                                        </Grid>

                                                    </Grid>


                                                    {/* <InputLabel id="mutiple-select-label">Language</InputLabel> className={classes.select}*/}
                                                </>

                                            </>
                                                :
                                                question.filedType === "select2" ? <>
                                                    {/* <InputLabel id="mutiple-select-label">Source</InputLabel> */}
                                                    <Select labelId="mutiple-select-label"
                                                        multiple
                                                        value={sourceSelected}
                                                        disabled={true}
                                                        onChange={handleSourceChange}
                                                        // onChange={e => handleChange(e, true)}
                                                        renderValue={(sourceSelected) => sourceSelected.join(", ")}
                                                        // renderValue={(selected) => null}
                                                        MenuProps={MenuProps}
                                                        style={{ width: 210, height: 40 }}
                                                        variant="outlined"
                                                    >
                                                        {/* <MenuItem value="">Select</MenuItem> */}
                                                        {sorceName.map((option) => (<MenuItem value={option.signupfrom}> <ListItemIcon>
                                                            <Checkbox checked={sourceSelected.length !== 0 ? sourceSelected.indexOf(option.signupfrom) > -1 : sourceSelected} />
                                                        </ListItemIcon> <ListItemText primary={option.signupfrom} /> </MenuItem>))}
                                                    </Select>
                                                </>
                                                    :
                                                    question.filedType === "select3" ? <>

                                                        <select
                                                            value={(formObject.reporting) ? (formObject.reporting) : ""}

                                                            // value ={(formObject[question.value]) ? getReportingid : ""}

                                                            // value={
                                                            //     reportName.filter((item)=>{            
                                                            //         if(item.id === formObject.reporting_id){
                                                            //             return item.id
                                                            //         }
                                                            //     })
                                                            // }


                                                            name={question.value}
                                                            onChange={e => handleChange(e, true)}

                                                            style={{ width: 209, height: 40 }}
                                                        >
                                                            <option value="">
                                                                {(formObject[question.value]) ? (formObject[question.value]) : ""}
                                                            </option>
                                                            {reportName.map((option, index) => {

                                                                return <option value={option.id}
                                                                >{option.empfname}</option>
                                                            })}
                                                        </select>
                                                    </>

                                                        : ""}
                            </Grid>
                        </Grid>
                    )
                })
            }
            <Grid container className={classes.submitButton}>
                <Grid item xs={false} sm={3} md={3} >
                </Grid>
                <Grid item xs={3} sm={3} md={3} style={{ display: "flex", columnGap: 30 }}>
                    <Button variant="contained" color="default" style={editFrom ? {} : { display: "none" }}>Cancel</Button>
                    <Button variant="contained" color="primary"
                        onClick={editFrom ? handleEditForm : handleSubmit}
                    // onClick={handleS}
                    >{editFrom ? "Update" : "Save"}</Button>
                </Grid>
            </Grid>
        </Grid>
    )

}


export default EditUser;


